import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Layout, Menu, Divider, Image } from "antd";
import {
  IoMdStats,
  IoMdOptions,
  IoMdContact,
  IoIosLogOut,
  IoMdHelpCircleOutline,
  IoIosMenu
} from "react-icons/io";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import AuthenticationButton from "./auth0/AuthenticationButton";
import UserProfile from "./auth0/UserProfile.js";
import logo from './DCDLogo.png';

const breakpoints = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px',
}

const styles = {
  logoText: () => ({
    color: "#66615B",
    fontSize: "115%",
    width: "100%",
    textAlign: "center",
    paddingTop: "20px",
    paddingBottom: "20px",
  }),
  menuItem: () => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  icon: () => ({
    fontSize: "200%",
  }),
  sidebarText: () => ({
    marginLeft: '10px',
    marginBottom: '5px'
  }),
  link: () => ({
    color: '#66615B'
  })
};

const Sidebar = ({ location, collapsed, setCollapsed }) => {
  const [broken, setBroken] = useState(false);

  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  if (!isAuthenticated) {
    return <></>;
  }
  
    return (
    <Layout.Sider
      onCollapse={() => {
          setCollapsed(!collapsed)
        }}
      collapsible
      breakpoint={breakpoints.md}
      onBreakpoint={()=>{ console.log(broken); setBroken(true) }}
      collapsed={collapsed}
      collapsedWidth={ broken ? 0 : 80 }
      defaultCollapsed={true}
      style={{
        //overflow: "auto",
        height: "100vh",
        position: "sticky",
        top: 0,
        left: 0,
        backgroundColor: '#ffffff'
      }}
      width='250'
      trigger={ broken ? <IoIosMenu/>  : null}
    >
     <Menu
        theme="light"
        style={{ backgroundColor: "white", color: "#66615B" }}
        mode="inline"
        selectedKeys={null}
      >
        <div
          style={{
            marginTop: "20px",
            height: "100%",
          }}
        >
          {collapsed ? (
            <Menu.Item key="logo" title={null} style={{pointerEvents: 'none'}} disabled={true}>
              <Image style={{marginTop: '10px'}} preview={false} width="100%" src={logo} alt="Logo" />
            </Menu.Item>
          ) : (
            <div style={styles.logoText()}>D C D</div>
          )}
        </div>
        <div
          style={{ width: "100%", paddingLeft: "20px", paddingRight: "20px" }}
        >
          <Divider style={{ width: "80%", border: "#C2C0BD 1px solid" }} />
        </div>
        <Menu.Item title={<UserProfile/>} key="/user" style={styles.menuItem()}>
          {collapsed ? <IoMdContact style={styles.icon()} /> : <UserProfile/>}
        </Menu.Item>
        <div
          style={{ width: "100%", paddingLeft: "20px", paddingRight: "20px" }}
        >
          <Divider style={{ width: "80%", border: "#C2C0BD 1px solid" }} />
        </div>
      </Menu>
      <Menu
        theme="light"
        style={{
          paddingBottom: "10px",
          backgroundColor: "white",
          color: "#66615B",
        }}
        mode="inline"
        selectedKeys={[location.pathname]}
      >
        <Menu.Item title={"Explore"} key="/explore" style={styles.menuItem()}>
        <Link style={styles.link()} to='/explore'><IoMdOptions style={styles.icon()} /></Link>
        {collapsed ? "" : <span style={styles.sidebarText()}><Link to="/explore">EXPLORE</Link></span>
       }
        </Menu.Item>
        <Menu.Item
          title={"Dashboard"}
          key="/dashboard"
          style={styles.menuItem()}
        >
          <Link style={styles.link()} to='/dashboard'><IoMdStats style={styles.icon()} /></Link>
          {collapsed ? "" : <span style={styles.sidebarText()}><Link to="/dashboard">DASHBOARD</Link></span>}
        </Menu.Item>
        <Menu.Item title={"Help"} key="help" style={styles.menuItem()}>
          <IoMdHelpCircleOutline style={styles.icon()} />
          {collapsed ? "" : <span style={styles.sidebarText()}>HELP</span>}
        </Menu.Item>
        <Menu.Item title={"Logout"} key="/auth" style={styles.menuItem()}>
          <Link onClick={()=>{logout({ returnTo: window.location.origin })}} style={styles.link()}><IoIosLogOut style={styles.icon()} /></Link>
          {collapsed ? "" : <span style={styles.sidebarText()}><AuthenticationButton/></span>}
        </Menu.Item>
      </Menu>
    </Layout.Sider>
  );
};

export default withRouter(Sidebar);
